import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap'; // Correct imports
import logo from "../Images/download1.png";
import Header1 from './Header1';
import Footer from './Footer';

function App() {
  return (
    <>
      <Header1 />
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Row className="align-items-center">
              {/* Mobile Screenshot on the Left */}
              <Col md={6} className="text-center">
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '320px',
                    paddingTop: '180%',
                    backgroundColor: '#fff',
                    borderRadius: '30px',
                    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    marginBottom: '20px',
                  }}
                >
                  {/* Phone frame with image inside */}
                  <img
                    src="https://play-lh.googleusercontent.com/SAbiGJpOaJWqzceyprnzmGQWv1XQ8Hb-7lqLOH_v-FW-WOII6v04UyILwRu_0jcBhUk3SCBi_lHMbkR-sIHRKOY=w2560-h1440-rw" // Replace with actual app screenshot
                    alt="App Screenshot"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              </Col>

              {/* Right Side Content (Title, Description, Download Buttons) */}
              <Col md={6}>
                <h1 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#333' }}>
                  Download Our App
                </h1>
                <p className="mb-4" style={{ fontSize: '1.2rem', color: '#777' }}>
                  Get the app on your favorite platform and enjoy seamless experience!
                </p>

                {/* Additional Description */}
                <p className="mb-4" style={{ fontSize: '1.1rem', color: '#555' }}>
                  With our app, you can enjoy features like easy navigation, secure transactions, and personalized recommendations.
                  Download now and start exploring a whole new way to shop!
                </p>

                {/* Google Play Button */}
                <Row className="mb-4 justify-content-start">
                  <Col md={12}>
                    <Button
                      variant="success"
                      href="https://play.google.com/store/apps/details?id=com.dectwin.fresh_mart&pcampaignid=web_share"
                      target="_blank"
                      block
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0px',
                        fontSize: '1.1rem',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#2b723d',
                        color: '#fff',
                        transition: 'background-color 0.3s ease, transform 0.3s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#1e5c2d'; // Darker green on hover
                        e.target.style.transform = 'scale(1.05)'; // Slight zoom effect
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#2b723d'; // Original green
                        e.target.style.transform = 'scale(1)'; // Reset zoom
                      }}
                    >
                      <img
                        src={logo}
                        alt="Google Play Store"
                        style={{ width: '120px', marginRight: '10px' }}
                      />
                      Get it on Google Play
                    </Button>
                  </Col>
                </Row>

                {/* Optional Description */}
                <Row className="mt-4 justify-content-start">
                  <Col md={12}>
                    <p style={{ fontSize: '1.1rem', color: '#555' }}>
                      Experience the best features on your device. Download now and start using our app!
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default App; 
